import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import * as constants from '../_model/string_literal';
import { forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OpenWebUIService {
  token: string = "";
  userList: any[] = [];
  userNo: number = 0;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  httpOptionsAuth = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.token,
    })
  };

  constructor(
    private http: HttpClient,
  ) { }

  getOWUUserList(page: number) {
    return this.http.get(
      constants.OWU_URL + `/api/v1/users/?page=${page}`,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + constants.OWU_ADMIN_API_KEY,
        }),
      }
    );
  }

  registerOpenWebUIUser(email: any, name: any, password: any) {
    return this.http.post(
      constants.OWU_URL + '/api/v1/auths/signup',
      JSON.stringify({ email, name, password, profile_image_url: ''}),
      this.httpOptions
    );
  }

  refreshOWUUserList(callback?: () => void) {
    this.getOWUUserList(1).subscribe({
      next: (value: any) => {
        const total = value.total;
        const pageSize = value.users.length;
        const totalPages = Math.ceil(total / pageSize);
        let allUsers = [...value.users];
        if (totalPages > 1) {
          const requests = [];
          for (let p = 2; p <= totalPages; p++) {
            requests.push(this.getOWUUserList(p));
          }
  
          forkJoin(requests).subscribe({
            next: (responses: any[]) => {
              responses.forEach(r => allUsers = [...allUsers, ...r.users]);
              this.userNo = total;
              this.userList = allUsers;

              callback?.();
            }
          });
        } else {
          this.userNo = total;
          this.userList = allUsers;

          callback?.();
        }
      }
    })
  }
}
